import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from './Modal.module.css'

const cosModal = (props) => {
    let btnList
    if (props.btnList) {
        btnList = props.btnList.map(btn => {
            if (btn.action === 'close') {
                return <Button className="mr-auto" key={btn.key} variant="secondary" onClick={() => btn.onClick()}>{btn.title}</Button>
            }
            else {
                return <Button key={btn.key} variant="primary" onClick={() => btn.onClick()}>{btn.title}</Button>
            }
        })
    }

    return (
        <Modal centered={true} size={props.size ? props.size : 'lg'} className={`${styles.mainModal}`} show={props.show} onHide={props.onHide}>
            
                <Modal.Header>
                    <Modal.Title>{props.modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body className={styles.modalBody}>
                    <p className={styles.p_moduleBody}>{props.modalBody}</p>
                </Modal.Body>
                {
                    btnList && btnList.length > 0 &&
                    <Modal.Footer>
                        {btnList}
                    </Modal.Footer>
                }
            
        </Modal>
    )
}

export default cosModal;